import listenMessage from './listen-message';

function babelCreateActivitySuccess(cb: any) {
  return listenMessage('CREATE_BABEL_ACTIVITY_SUCCESS', cb);
}

function babelCreateActivityFail(cb: any) {
  return listenMessage('CREATE_BABEL_ACTIVITY_FAIL', cb);
}

function babelCancelCreateActivity(cb: any) {
  return listenMessage('CANCEL_CREATE_BABEL_ACTIVITY', cb);
}

function unlogin(cb: any) {
  return listenMessage('UNLOGIN', cb);
}

export default {
  babelCreateActivitySuccess,
  babelCreateActivityFail,
  babelCancelCreateActivity,
  unlogin,
};
